import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { About } from '../components/About';
import { FAQ } from '../components/FAQ';
import { BlogSection } from '../components/BlogSection';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';

export function HomePage() {
  return (
    <div className="min-h-screen bg-zinc-900">
      <Helmet>
        <title>Premier Renovation Company | Westchester County NY & Fairfield County CT</title>
        <meta name="description" content="Leading renovation company serving Westchester County, NY and Fairfield County, CT. Licensed and insured in both states. Specializing in kitchen renovations, bathroom remodeling, and home improvements." />
        <meta name="keywords" content="renovation company Westchester, renovation company Fairfield, licensed renovation contractor NY CT, kitchen renovation Westchester, bathroom remodeling Fairfield, home improvement NY CT" />
        <link rel="canonical" href="https://renovationwestchester.com" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="Premier Renovation Company | Westchester & Fairfield Counties" />
        <meta property="og:description" content="Leading renovation company serving Westchester County, NY and Fairfield County, CT. Licensed and insured in both states. Expert renovation services." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://renovationwestchester.com" />
        
        {/* Additional SEO Tags */}
        <meta name="geo.region" content="US-NY, US-CT" />
        <meta name="geo.placename" content="Westchester County, Fairfield County" />
        <meta name="geo.position" content="41.0340;-73.7629" />
        <meta name="ICBM" content="41.0340, -73.7629" />
        <meta name="robots" content="index, follow, max-image-preview:large" />
      </Helmet>
      
      <Hero />
      <Services />
      <About />
      <FAQ />
      <BlogSection />
      <Contact />
      <Footer />
    </div>
  );
}